// extracted by mini-css-extract-plugin
export var footer = "_kw-0";
export var inherit = "_kw-1";
export var input = "_kw-2";
export var modalContent = "_kw-3";
export var quillEditor = "_kw-4";
export var subtitle = "_kw-5";